import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../services/authService";

const ProtectedRoute = ({ component: Dash }) => {
  const nav = useNavigate();
  const authService = AuthService();
  const user = authService.getCurrentUser();
  console.log(user);
  useEffect(() => {
    if (!user) {
      nav("/login", { replace: true });
    }
  }, []);

  return <Dash />;
};

export default ProtectedRoute;
